import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import './Header.css';
import dscLogo from '../assets/dsc-logo.png';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const isActive = (path) => {
    return location.pathname === path ? 'active' : '';
  };

  return (
    <header className="header">
      <div className="container">
        <div className="logo">
          <Link to="/">
            <img 
              src={dscLogo}
              alt="DSC Logo" 
              className="logo-image"
              onError={(e) => {
                console.log('Logo PNG import failed to load:', e.target.src);
                e.target.style.display = 'none';
              }}
              onLoad={() => console.log('Logo PNG import loaded successfully')}
            />
            <div className="logo-text">
              <h1>DSC.JSC</h1>
              <p>Trắc địa Hải Phòng</p>
            </div>
          </Link>
        </div>
        
        <nav className={`nav ${isMenuOpen ? 'nav-open' : ''}`}>
          <ul>
            <li>
              <Link to="/" className={isActive('/')} onClick={() => setIsMenuOpen(false)}>
                Trang chủ
              </Link>
            </li>
            <li>
              <Link to="/about" className={isActive('/about')} onClick={() => setIsMenuOpen(false)}>
                Giới thiệu
              </Link>
            </li>
            <li>
              <Link to="/services" className={isActive('/services')} onClick={() => setIsMenuOpen(false)}>
                Dịch vụ
              </Link>
            </li>
            <li>
              <Link to="/equipment" className={isActive('/equipment')} onClick={() => setIsMenuOpen(false)}>
                Thiết bị
              </Link>
            </li>
            <li>
              <Link to="/projects" className={isActive('/projects')} onClick={() => setIsMenuOpen(false)}>
                Dự án
              </Link>
            </li>
            <li>
              <Link to="/careers" className={isActive('/careers')} onClick={() => setIsMenuOpen(false)}>
                Tuyển dụng
              </Link>
            </li>
            <li>
              <Link to="/contact" className={isActive('/contact')} onClick={() => setIsMenuOpen(false)}>
                Liên hệ
              </Link>
            </li>
          </ul>
        </nav>

        <div className="menu-toggle" onClick={toggleMenu}>
          <span></span>
          <span></span>
          <span></span>
        </div>
      </div>
    </header>
  );
};

export default Header;